<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-03 10:56:19
 * @LastEditors: yuka
 * @LastEditTime: 2019-08-01 20:41:13
 * @Description: 合作伙伴
 -->
<template>
  <div class="partner-wrapper">
    <h3 class="title">合作伙伴</h3>
    <ul class="icon-wrapper">
      <li>
        <img src="https://files.jinr.com/jinr-index/img/index-partner-01.png" alt="" srcset="" />
      </li>
      <!-- <li>
        <img src="https://files.jinr.com/jinr-index/img/index-partner-02.png" alt="" srcset="" />
      </li> -->
      <li>
        <img
          src="https://files.jinr.com/jinr-index/img/index-partner-03.png"
          style="height:0.33rem"
          alt=""
          srcset=""
          class="special"
        />
      </li>
      <li>
        <img
          src="https://files.jinr.com/jinr-index/img/index-partner-04.png"
          style="height:0.55rem"
          alt=""
          srcset=""
        />
      </li>
      <li>
        <img
          src="https://files.jinr.com/jinr-index/img/index-partner-05.png"
          style="height:0.36rem"
          alt=""
          srcset=""
          class="special"
        />
      </li>
    </ul>
    <p class="tips-invest">市场有风险、出借需谨慎</p>
  </div>
</template>
<script>
export default {
  name: 'partner'
};
</script>
<style lang="less" scoped>
.partner-wrapper {
  width: 7.5rem;
  height: 4.18rem;
  background: url('https://files.jinr.com/jinr-index/img/m-partner-bg.png');
  .title {
    width: 100%;
    padding: 0.68rem 0 0;
    margin: 0 auto;
    font-family: 'PingFangSC-Medium';
    font-size: 0.32rem;
    color: #333333;
    text-align: center;
  }
  .icon-wrapper {
    display: flex;
    flex-wrap: wrap;
    margin: 0.3rem auto 0;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;

    li {
      width: 1.8rem;
      height: 0.84rem;
      background: #fff;
      line-height: 0.84rem;
      margin: 0 0.11rem 0.21rem;
      box-shadow: 0rem 0.02rem 0.1rem 0rem rgba(13, 116, 227, 0.21);
    }
    img {
      height: 0.59rem;
      vertical-align: middle;
    }
  }
  .tips-invest {
    font-size: 0.2rem;
    font-weight: normal;
    font-stretch: normal;
    line-height: 0.18rem;
    letter-spacing: 0.06rem;
    color: #696969;
    margin: 0.2rem 0 0;
  }
}
</style>
